import { Component, Inject, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {
	MatDialogRef,
	MatDialog,
	MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { PreloaderService } from "@core";
import { DataService } from "@core/bootstrap/data.service";
import { LanguagePipe } from "@shared/pipes/language.pipe";
import { SweetAlertService } from "@shared/services/sweet-alert.service";

@Component({
	selector: "app-qt-add-edit",
	templateUrl: "./qt-add-edit.component.html",
	styleUrls: ["./qt-add-edit.component.scss"],
})
export class QtAddEditComponent implements OnInit {
	lang_key = localStorage.getItem("lang_key") || "en";
	typeForm: FormGroup;
	type_data;
	edit_mode = false;
	constructor(
		private fb: FormBuilder,
		public ds: DataService,
		private sweetAlert: SweetAlertService,
		private lang: LanguagePipe,
		private spinner: PreloaderService,
		private dialogRef: MatDialogRef<QtAddEditComponent>,
		public dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data
	) {
		this.type_data = data?.type_data;
		this.edit_mode = this.type_data ? true : false;
	}

	ngOnInit(): void {
		this.buildForm();
		if (this.edit_mode) {
			this.setEditData();
		}
	}

	buildForm() {
		this.typeForm = this.fb.group({
			quotation_types_name_ar: [null, Validators.required],
			quotation_types_name_en: [null, [Validators.required]],
			quotation_types_keyword: [null, [Validators.required]],
		});
	}
	setEditData() {
		this.typeForm
			.get("quotation_types_name_ar")
			.setValue(this.type_data.quotation_types_name_ar);
		this.typeForm
			.get("quotation_types_name_en")
			.setValue(this.type_data.quotation_types_name_en);
		this.typeForm
			.get("quotation_types_keyword")
			.setValue(this.type_data.quotation_types_keyword);
	}

	addEditType() {
		this.spinner.show();
		let param = new FormData();
		let url = "quotation_setting/add_quotation_types";
		if (this.edit_mode) {
			param.append("quotation_types_id", this.type_data.quotation_types_id);
			url = "quotation_setting/update_quotation_types";
		}
		param.append(
			"quotation_types_name_ar",
			this.typeForm.value.quotation_types_name_ar
		);
		param.append(
			"quotation_types_name_en",
			this.typeForm.value.quotation_types_name_en
		);
		param.append(
			"quotation_types_keyword",
			this.typeForm.value.quotation_types_keyword
		);
		this.ds.post(url, param).subscribe(
			(res) => {
				this.spinner.hide();
				if (res.status) {
					this.sweetAlert.successToast(
						this.lang.transform("lang_success"),
						2000
					);
					this.dialogRef.close(true);
				} else {
					this.sweetAlert.errorToast(res.error, 2000);
				}
			},
			(err) => {
				this.spinner.hide();
				this.sweetAlert.errorToast(
					this.lang.transform("lang_internal_server_error"),
					2000
				);
			}
		);
	}
}
